import React from "react";
import { MaterialIcon } from "@loanbossinc/component-library";

import { determineFieldType, determineValueFormatting } from "../lineItemManagement";
import { FieldName, PropertyFieldWrapper, PropertyName, SelectedPropertyLeftWrapper, StyledFieldType } from "../styles";

import { StyledIconButton, StyledPropertySelectWrapper, StyledSelectButton } from "./styles";

const SelectedPropertyListItem = ({ property, setDrawerSelections, setNewLineItemSelections }) => (
  <>
    <SelectedPropertyLeftWrapper>
      <StyledIconButton
        onClick={() => {
          setDrawerSelections({ currentSectionName: "comparison-field-selection" });
          setNewLineItemSelections({ propertyIdSelected: property.propertyId });
        }}
        disableRipple
      >
        <MaterialIcon style={{ color: "#005AA9", width: "18px" }} iconName="create" />
      </StyledIconButton>
      <PropertyFieldWrapper>
        <PropertyName>{property.propertyName}</PropertyName>
        <div>
          <FieldName>{property.selectedField.name}</FieldName>
          {" "}
          <StyledFieldType>{`(${determineFieldType(property.selectedField)})`}</StyledFieldType>
        </div>
      </PropertyFieldWrapper>
    </SelectedPropertyLeftWrapper>
    {determineValueFormatting(property.selectedField.type, property.selectedField.value)}
  </>
);

const PropertyListItem = props => {
  const { property, onPropertySelected } = props;

  return (
    <StyledPropertySelectWrapper>
      {property.selectedField ? (
        <SelectedPropertyListItem {...props} />
      ) : (
        <>
          <PropertyName>{property && property.propertyName}</PropertyName>
          <StyledSelectButton id="select-property-btn" label="Select" onClick={onPropertySelected} />
        </>
      )}
    </StyledPropertySelectWrapper>
  );
};

export default PropertyListItem;
